import { HStack, Stat, StatHelpText, StatLabel, StatNumber } from "@chakra-ui/react"
import { Mask } from "config"

export default function General({ data:distributor }){
    return(
    <>
    <HStack>

        <Stat>
            <StatLabel>Saldo atual</StatLabel>
            <StatNumber children={`R$ ${Mask.price(distributor.data?.cash_balance)}`} />
            <StatHelpText>Saldo de "haver" do núcleo</StatHelpText>
        </Stat>

    </HStack>
    </>
    )
}
